export default "__VITE_ASSET__DVprslnb__"